import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectHasPermissionsWildcard, selectLoaded, selectPermissions } from '../selectors/session.selector';
import { sessionActions } from '../actions/session.actions';
import { Permission } from '../models';

@Service()
export class SessionFacade {
    private readonly store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly permissions = this.store.selectSignal(selectPermissions);
    readonly hasPermissionsWildcard = this.store.selectSignal(selectHasPermissionsWildcard);

    hasPermission(permission: Permission): boolean {
        return this.hasPermissionsWildcard() || this.permissions().includes(permission);
    }

    getSession(): void {
        this.store.dispatch(sessionActions.getSession());
    }

    clear(): void {
        this.store.dispatch(sessionActions.clear());
    }
}
